/* Odds Comfort: make the hero and film-band videos start and loop on their own.
   Browsers allow muted autoplay, but some pause it when the tab or slide is hidden or the data saver is on,
   so play it explicitly when it is on screen and pause it when it is not. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function prep(v) {
    v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('loop', '');
  }
  function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () { /* waits for the next trigger */ }); }
  function init(scope) {
    var vids = Array.prototype.slice.call((scope || document).querySelectorAll('video.odds-vid'));
    if (!vids.length || reduce) return;
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) play(e.target); else e.target.pause(); });
    }, { threshold: 0.15 }) : null;
    vids.forEach(function (v) {
      if (v.__oddsVid) return; v.__oddsVid = true;
      prep(v);
      if (io) io.observe(v); else play(v);
      v.addEventListener('canplay', function () { if (v.paused && v.getBoundingClientRect().height) play(v); });
    });
  }
  /* some browsers only allow the first play after a touch or click */
  ['touchstart', 'click', 'scroll'].forEach(function (t) {
    window.addEventListener(t, function () {
      document.querySelectorAll('video.odds-vid').forEach(function (v) {
        var r = v.getBoundingClientRect();
        if (v.paused && r.bottom > 0 && r.top < window.innerHeight && getComputedStyle(v).visibility !== 'hidden') play(v);
      });
    }, { passive: true, once: true });
  });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
})();
